import type { FlavorConfig } from '@/types/flavor';

/**
 * Sideconvo DEV Environment Configuration
 */
const config: FlavorConfig = {
  name: 'sideconvo',
  environment: 'dev',
  appTitle: 'Lead Management | Sideconvo.ai [DEV]',
  firestoreDB: 'lead-management-dev',
  demoSiteBaseUrl: 'https://dev.client.sideconvo.ai',
  snapshotBucket: 'snapshot-sideconvo-dev',
};

export default config;
